/**
 * Processings: long work over a Patient's material that any member who may
 * read it can follow, stop and remove — the workspace tile, the registry, the
 * page of one processing and the names of its closed lists.
 *
 * A KIND, A STATUS AND A STAGE ARE NAMED HERE ONCE. The Files strip, the EMR
 * line and the registry read the same words through `shared/processing`, so a
 * stage cannot be called one thing on the grid and another above the Files.
 */
export const processing = {
  'processing.title': 'Processings',
  'processing.kind.externalEntries': 'EMR entries from documents',
  'processing.status.queued': 'Queued',
  'processing.status.running': 'Running',
  'processing.status.needsAction': 'Needs action',
  'processing.status.failed': 'Failed',
  'processing.status.succeeded': 'Completed',
  'processing.status.cancelled': 'Cancelled',
  'processing.stage.externalEntries.recognizing': 'Recognizing text',
  'processing.stage.externalEntries.segmenting': 'Marking pages',
  'processing.stage.externalEntries.grouping': 'Finding care events',
  'processing.stage.externalEntries.extracting': 'Filling entries',
  'processing.stage.externalEntries.review': 'Review',
  'processing.tileDescription': 'Recognition and analysis of patient documents',
  'processing.itemTitle': 'Processing',
  'processing.columnKind': 'Kind',
  'processing.columnPatient': 'Patient',
  'processing.columnSubject': 'Files',
  'processing.columnRequester': 'Requested by',
  'processing.columnStarted': 'Started',
  'processing.columnStage': 'Stage and progress',
  'processing.columnStatus': 'Status',
  'processing.columnUpdated': 'Updated',
  'processing.columnActions': 'Actions',
  'processing.filterMine': 'Mine',
  'processing.loading': 'Loading processings',
  'processing.loadFailed': 'Processings could not be loaded.',
  'processing.empty': 'No processings yet',
  'processing.emptyDetail': "A processing starts from a patient's Files: tick documents and choose what to do with them.",
  'processing.filteredEmpty': 'No processings match the filters',
  'processing.filteredEmptyDetail': 'Unfinished processings are shown first; clear the Status filter to see every one.',
  'processing.resultCountOne': '{count} processing',
  'processing.resultCountMany': '{count} processings',
  'processing.progress': '{done} of {total}',
  'processing.awaiting': 'To review: {count}',
  'processing.cancel': 'Cancel',
  'processing.remove': 'Delete',
  'processing.cancelNamed': 'Cancel processing {name}',
  'processing.removeNamed': 'Delete processing {name}',
  'processing.cancelTitle': 'Cancel this processing?',
  'processing.cancelDetail': 'No new step will start. What is already saved to the record stays.',
  'processing.cancelKeep': 'Keep it',
  'processing.cancelConfirm': 'Cancel processing',
  'processing.cancelFailed': 'The processing could not be cancelled. Try again.',
  'processing.removeTitle': 'Delete this processing?',
  'processing.removeDetail': 'It leaves the list for everyone. What it saved to the record stays.',
  'processing.removeKeep': 'Keep it',
  'processing.removeConfirm': 'Delete processing',
  'processing.removeFailed': 'The processing could not be deleted. Try again.',
  'processing.actChanged': 'This processing changed meanwhile, and its current state is shown now.',
  'processing.actGone': 'This processing no longer exists.',
  'processing.invalidLink': 'This processing link is not valid',
  'processing.invalidLinkDetail': 'Open the processing from the Processings list again.',
  'processing.notFound': 'Processing not found',
  'processing.notFoundDetail': 'It may have been deleted, or you may not have access to it.',
  'processing.loadingOne': 'Loading the processing',
  'processing.factFinished': 'Finished',
  'processing.factCancelledBy': 'Cancelled by',
  'processing.unknownKind': 'This version of the application cannot show the details of this kind of processing.',
  'processing.patientLabel': 'Patient',
} as const
